module.exports = __webpack_public_path__ + "img/icon-wechat-btn.052a0ef7.png";